"use strict";
// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * Humla Health API
 * Humla Health API
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.InterestWorkType = void 0;
exports.instanceOfInterestWorkType = instanceOfInterestWorkType;
exports.InterestWorkTypeFromJSON = InterestWorkTypeFromJSON;
exports.InterestWorkTypeFromJSONTyped = InterestWorkTypeFromJSONTyped;
exports.InterestWorkTypeToJSON = InterestWorkTypeToJSON;
exports.InterestWorkTypeToJSONTyped = InterestWorkTypeToJSONTyped;
/**
 *
 * @export
 */
exports.InterestWorkType = {
    FullTime: 'FULL_TIME',
    PartTime: 'PART_TIME',
    PerDiem: 'PER_DIEM',
    Other: 'OTHER'
};
function instanceOfInterestWorkType(value) {
    for (const key in exports.InterestWorkType) {
        if (Object.prototype.hasOwnProperty.call(exports.InterestWorkType, key)) {
            if (exports.InterestWorkType[key] === value) {
                return true;
            }
        }
    }
    return false;
}
function InterestWorkTypeFromJSON(json) {
    return InterestWorkTypeFromJSONTyped(json, false);
}
function InterestWorkTypeFromJSONTyped(json, ignoreDiscriminator) {
    return json;
}
function InterestWorkTypeToJSON(value) {
    return value;
}
function InterestWorkTypeToJSONTyped(value, ignoreDiscriminator) {
    return value;
}
//# sourceMappingURL=InterestWorkType.js.map